
import { Component, Mixins } from 'vue-property-decorator';
import "vue2-editor/dist/vue2-editor.css";
import { VueEditor } from "vue2-editor";
import AuthMixin from '@/common/mixins/auth.mixin';
import { mapState } from 'vuex';
import ValidatedFormMixin from '@/common/mixins/validated-form.mixin';
import { formatDate } from '@/utils/date.util';
import { VacancyApplicantDto, VacancyApplicantNoteDto, VacancyApplicantNoteFormDto } from '@/types/vacancy.type';

@Component({
  components: {
    VueEditor
  },
  computed: {
    ...mapState("Vacancy", { selectedApplicant: "vacancyApplicant", form: "vacancyNoteForm" })
  }
})
export default class VacancyCreateEditNoteComponent extends Mixins(AuthMixin, ValidatedFormMixin) {
  selectedApplicant!: VacancyApplicantDto;
  form!: VacancyApplicantNoteFormDto;

  selectedDeleteId = 0;

  loading = false;
  formatDate = formatDate;

  editorToolbar = [
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    ["clean"]
  ];

  get initials(): string {
    if (this.selectedApplicant){
      const splitName = this.selectedApplicant.name.split(" ");

      return splitName.map(n => n[0]).join("");
    }

    return "";
  }

  async deleteNote(): Promise<void> {
    await this.$store.dispatch("Vacancy/deleteNote", this.selectedDeleteId);
    this.$emit("delete", this.selectedApplicant.userId);
    this.resetForm();
  }

  showDeleteModal(id: number): void {
    this.selectedDeleteId = id;
    this.$bvModal.show("note-delete-modal");
  }

  onEdit(data: VacancyApplicantNoteDto): void {
    const userInfo = this.userInfo();

    if (!userInfo) {
      return;
    }

    const form = {
      id: data.id,
      userId: userInfo.sub,
      value: data.note
    } as VacancyApplicantNoteFormDto

    this.$store.commit('Vacancy/updateField', { path: 'vacancyNoteForm', value: form });
  }

  cancelEdit(): void {
    this.resetForm();
  }

  async save(): Promise<void> {
    await this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        try {
          this.form.userId = this.selectedApplicant.userId;

          await this.$store.dispatch("Vacancy/saveNote", this.form);
        }
        catch {
          return;
        }
        this.loading = false;
        this.$emit("create", this.selectedApplicant.userId);
        this.resetForm();
      }
    });
  }

  resetForm(): void {
    this.$store.commit('Vacancy/updateField', { path: 'vacancyNoteForm', value: new VacancyApplicantNoteFormDto() });
  }

  closeModal(): void {
    this.resetForm();
    this.$bvModal.hide('vacancy-create-edit-note-modal');
  }

  onCloseModal(): void {
    if (this.form.id) {
      if (this.form.value !== this.selectedApplicant.notes.find(note => note.id === this.form.id)?.note) {
        return this.$bvModal.show('note-close-modal');
      }
    }
    else {
      if (this.form.value) {
        return this.$bvModal.show('note-close-modal');
      }
    }

    this.closeModal();
  }
}
